/**
 * Parallax background feature (disabled)
 * Background-position animation on body caused full-page repaints on every
 * scroll frame which killed mobile performance. The background texture is now
 * static on body — no per-frame position changes.
 */

import type Lenis from 'lenis'
import type { ParallaxConfig, ParallaxInstance } from './types'

const noop = () => {}

export function setupParallaxBackground(
  _lenisInstance: Lenis | null,
  _config: Partial<ParallaxConfig> = {},
): ParallaxInstance {
  return { destroy: noop, update: noop }
}
